<template>
    <RouterLink
        v-slot="{ href, navigate, isActive, isExactActive }"
        :to="to"
        custom
    >
        <TabHeaderItem
            v-bind="$attrs"
            :active="exact ? isExactActive : isActive"
            @click.native="navigate"
        >
            <a :href="href" class="tab-header-link-link">
                <slot>
                    <Icon v-if="icon" :name="icon" />

                    {{ label }}
                </slot>
            </a>
        </TabHeaderItem>
    </RouterLink>
</template>

<script>
import TabHeaderItem from './TabHeaderItem';
import { Icon } from '../Icon';

export default {
    name: 'DsTabHeaderLink',

    inheritAttrs: false,

    components: {
        TabHeaderItem,
        Icon,
    },

    props: {
        to: [String, Object],

        exact: Boolean,

        icon: String,

        label: String,
    },
};
</script>

<style lang="scss" scoped>
@import "../../styles/common";

.tab-header-link-link {
    display: flex;
    align-items: center;
    gap: $spacing-100;
    color: inherit;

    &:hover {
        text-decoration: none;
    }
}
</style>
